import PropTypes from "prop-types"
import React, { Fragment } from "react"

import { ColumnPropType } from "./types"

const PrintTable = ({ data, columns, idKey = "id", renderSubRow }) => {
  const visibleColumns = columns.filter((col) => !col.hide && !col.printHide)

  return (
    <div className="hidden print:block" data-testid="print-table">
      <table className="w-full table-auto border-collapse">
        <thead>
          <tr>
            {visibleColumns.map((col) => (
              <th
                key={col.key}
                className="border-b border-gray-300 px-1 py-1 text-left font-semibold print:text-[10px]"
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <Fragment key={row[idKey] ?? row.id ?? index}>
              <tr>
                {visibleColumns.map((col) => (
                  <td
                    key={col.key}
                    className="border-b border-gray-200 px-1 py-1 print:text-[10px]"
                  >
                    {col.render ? col.render(row) : row[col.key]}
                  </td>
                ))}
              </tr>
              {renderSubRow?.(row, visibleColumns.length)}
            </Fragment>
          ))}
        </tbody>
      </table>
    </div>
  )
}

PrintTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(ColumnPropType).isRequired,
  idKey: PropTypes.string,
  renderSubRow: PropTypes.func,
}

export default PrintTable
